// src/components/navigation/ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppShellSkeleton } from "../common/SkeletonLoader";
import { selectIsAuthenticated, selectIsInitializing } from "../../auth";
import { authLoginUrl } from "../../config/routePaths";

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isInitializing = useSelector(selectIsInitializing);
  const location = useLocation();

  // Show loading spinner while checking authentication state
  if (isInitializing) {
    return <AppShellSkeleton message="Loading your session…" />;
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search || ""}`;
    return <Navigate to={authLoginUrl(returnTo)} replace state={{ from: location }} />;
  }

  return children;
}
